import { Skeleton } from "@material-ui/lab";
import AuthService from "Lib/API/Auth/index";
import { useHistory } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import CloseIcon from "@material-ui/icons/Close";
import React, { useState, useEffect } from "react";
import { Drawer, Typography, Box, IconButton } from "@material-ui/core";
// component
import { hasAccessToModule } from "utils/functions";
import MainTabs from "components/mainTabs/MainTabs";
import LazyAvatar from "components/LazyAvatar/index";
// direct import
import Events from "./Events";
import Profile from "./Profile";
import { useStyles } from "./style";
import ProfileView from "./ProfileView";
import ContactActions from "./ContactActions";
import { member_type_colors } from "./helper";

export default function SideDrawer({
  open,
  onClose,
  account,
  selectedData,
  handleEvent,
}) {
  const classes = useStyles();
  const history = useHistory();
  const colors = ["#4CAF50", "#2A99FA"];
  const { getAccessTokenSilently } = useAuth0();
  const canAccessPastoral = hasAccessToModule("pastoral");

  const [tab, setTab] = useState("Personal");
  const [contactData, setContactData] = useState(null);
  const [loading, setGetContactLoading] = useState(null);

  const account_tabs = [
    {
      title: "Personal",
      value: "Personal",
      content: (
        <ProfileView
          member={{
            email_address: contactData?.email_address,
            mobile_number: contactData?.mobile_number,
            date_of_birth: contactData?.date_of_birth,
            gender: contactData?.gender,
          }}
        />
      ),
    },
    ...(canAccessPastoral
      ? [
          {
            title: "Easycare",
            value: "Easycare",
            width: "130px",
            content: (
              <Events selectedData={selectedData} handleEvent={handleEvent} />
            ),
          },
        ]
      : []),
  ];

  const calculateProfileCompletion = (user) => {
    const {
      account,
      createdAt,
      id,
      member_id,
      profile_img,
      relationship,
      _id,
      backGround,
      account_id,
      organization,
      updatedAt,
      __v,
      ...data
    } = { ...(user ? user : {}) };
    const insertedValues = Object.values(data);
    const insertedValuesLng = insertedValues.filter((it) => {
      if (it !== "") {
        if (typeof it === "object") {
          if (it?.formattedAddress !== undefined) {
            return true;
          } else return false;
        }
        return true;
      } else return false;
    })?.length;
    return Math.round((insertedValuesLng / 23) * 100) > 100
      ? 100
      : Math.round((insertedValuesLng / 23) * 100);
  };

  const getContactHandler = async () => {
    setGetContactLoading(true);
    const token = await getAccessTokenSilently();
    AuthService.getContactById(selectedData?.easy_contact_id, token)
      .then((res) => {
        if (!res?.length) return;
        const result = { ...res?.[0] };
        result.id = result._id;
        const random = Math.floor(Math.random() * 2);
        if (!result.profile_img) {
          result.backGround = colors[random];
        }
        result.profile_completion = calculateProfileCompletion(result);
        setContactData(result);
      })
      .catch((err) => {
        // Handle error
      })
      .finally(() => {
        setGetContactLoading(false);
      });
  };

  useEffect(() => {
    if (!account?.main_contact?.account_id) return;
    getContactHandler();
  }, [account?.main_contact?.account_id]);

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      classes={{ paper: classes.drawerPaper }}
    >
      <Box display="flex" justifyContent="flex-end">
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Box>

      {loading ? (
        <>
          <Skeleton
            variant="circular"
            width={110}
            height={110}
            className={classes.avatar}
            style={{ marginTop: 35, borderRadius: "50%" }}
          />
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <Skeleton
              variant="text"
              width="40%"
              height={30}
              style={{ borderRadius: 6 }}
            />
            <Skeleton
              variant="text"
              width="40%"
              height={30}
              style={{ borderRadius: 6 }}
            />
          </Box>
          <Skeleton
            variant="rect"
            width="100%"
            height={50}
            style={{ marginTop: 16, borderRadius: 6 }}
          />
          <Skeleton
            variant="rect"
            width="100%"
            height={50}
            style={{ marginTop: 8, borderRadius: 6 }}
          />
          <Skeleton
            variant="rect"
            width="100%"
            height={"50vh"}
            style={{ marginTop: 16, borderRadius: 6 }}
          />
        </>
      ) : (
        <>
          <LazyAvatar
            src={contactData?.profile_img}
            alt={contactData?.full_name}
            fallback={contactData?.full_name?.charAt(0) ?? "?"}
            className={classes.avatar}
          />

          <Typography variant="h6" className={classes.userName}>
            {contactData?.full_name}
          </Typography>
          <Typography variant="body2" className={classes.userId}>
            Member {`#${contactData?.member_id}`}
          </Typography>
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <Box
              className="member-type"
              sx={{
                width: "auto",
                display: "flex",
                justifyContent: "center",
                paddingLeft: 20,
                paddingRight: 20,
              }}
              style={
                contactData?.account_permission === "admin"
                  ? member_type_colors[1]
                  : member_type_colors[0]
              }
            >
              {contactData?.account_permission === "admin"
                ? "Admin"
                : "Family member"}
            </Box>
          </Box>

          <ContactActions
            email={contactData?.email_address}
            phone={contactData?.mobile_number}
            content={contactData?.mobile_number}
          />

          {contactData?.profile_completion && (
            <Profile
              profile={contactData?.profile_completion || 0}
              handleClick={() => {
                history.push(
                  `/member-details/${contactData?.account_id}/family-member`,
                  contactData
                );
              }}
            />
          )}

          <MainTabs
            className="mt-8"
            tabs={account_tabs}
            activeTab={tab}
            onTabsChange={(tab) => setTab(tab?.value)}
          />

          <Box mt={2}>
            {account_tabs?.find((t) => t?.value === tab)?.content}
          </Box>
        </>
      )}
    </Drawer>
  );
}
